import React, { Suspense } from 'react';
import { Spinner } from '@/components/shared';

import PharmaprixPharmacyDisclaimer from '../pharmaprix-pharmacy-disclaimer';
import {
  ComponentItem,
  IPharmacyAndServicesProps,
  Service,
  IPharmacistInformation,
} from './pharmacy-and-services.interface';
import StoreInformation from '../store-information';
import PharmacistInformation from '@/components/pharmacist-information/pharmacist-information.component';
import { TStoreDetailsResults } from '@/components/store-details/store-details.interface';
import { STORE_TYPES } from '../store-details/constants';
import { Province } from '../pharmacist-information/pharmacist-information.interface';
import ServicesList from '@/components/services-list';

const PharmacyAndServices: React.FC<IPharmacyAndServicesProps> = ({
  layout,
  storeId,
  isPhx,
  storeType,
  googleMapsStoreData
}) => {
  const pharmacyAndServices = layout?.sections?.mainContentCollection?.components?.find(
    (item: ComponentItem) => item.componentId === 'pharmacyServicesComponent'
  )?.data as Service[];

  const pharmacistInformation = layout?.sections?.mainContentCollection?.components?.find(
    (item: ComponentItem) => item.componentId === 'pharmacistInfoComponent'
  ) as IPharmacistInformation;

  const { province } = layout?.sections?.mainContentCollection?.components?.find(
    (item: ComponentItem) => item.componentId === 'storeDetailsComponent'
  )?.data as TStoreDetailsResults;

  return (
    <>
      <StoreInformation layout={layout} activeIndex={1} googleMapsStoreData={googleMapsStoreData} />
      <Suspense fallback={<Spinner />}>
        <ServicesList data={pharmacyAndServices} titleId="pharmacyServices" marginTop="6rem" />
        {/* TODO: Add banner when isSSP == false */}
        <PharmacistInformation
          storeId={storeId}
          province={province as Province}
          storeType={storeType}
          pharmacistInformation={pharmacistInformation}
        />
        {(isPhx || storeType === STORE_TYPES.STTP_PSS) && <PharmaprixPharmacyDisclaimer />}
      </Suspense>
    </>
  );
};

export default PharmacyAndServices;
